<!--
    !!! WARNING !!!
    This input has to be generic
    The current situation makes it just aviable for processes
    The values of processes recived from back does not permits a tree view



     <TreeviewSelect
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - items → now ( [[value, text], [1, 'User 1']] ) , correct ([{value, text, children, ...} ], [{1, 'User 1', [{...}], ...}])
     - value
     - label
     - placeholder
     - multiple (Not now, possible )
-->

<template>
  <v-menu
    v-model="menu"
    offset-y
    :disabled="!!props.readonly"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field      
        :value="text"
        :label="props.label"
        :class="[
          props.class || props.readonly ? 'qmkey-form-input-readonly' : 'qmkey-form-input',
          { required: props.required },
        ]"
        v-on="on"
        :rules="rules"
        outlined
        dense
        background-color="#f2f2f2"
        @input="search_text"
        @focus="is_writing = true"
        @blur="is_writing = false;"
        :disabled="!!props.disabled"
        :readonly="!!props.readonly"
        :placeholder="props.placeholder"
      >
        <template v-slot:append>
          <v-icon v-if="!props.readonly && !props.disabled && (text && text.length > 0)" @click="clear">
            mdi-close
          </v-icon>
          <v-icon v-if="!props.readonly && !props.disabled" v-on="on">
            mdi-menu-down
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <div
      class="qmkey-menu-content-tree"
    >
    <v-treeview
        ref="directory-tree"
        :value="selection"
        :active="selection"
        dense
        :search="search"
        :items="items_tree"
        return-object
        selection-type="independent"
      >
        <template v-slot:prepend="{item, selected, active}">
          <v-btn
            icon
            @click="manage_active(item)"
            :class="selected ? 'accent--text' : ''"
          >
            <v-icon medium> {{ (selected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline') }}</v-icon>
          </v-btn>
        </template>
        <template v-slot:label="{item}">
          <span 
            style="font-size: small;"
            class="qmkey-clickable-tree-item"
            @click="manage_active(item)"
          >
            {{ item.name }}
          </span>
        </template>
      </v-treeview>
    </div>
  </v-menu>
</template>

<style lang="scss">
  @import '@/sass/modalform.scss';
  .qmkey-clickable-tree-item {
    cursor: pointer;
  }
  .qmkey-menu-content-tree {
    background-color: white;
    max-height: 300px;
    overflow-y: auto;
  }
</style>

<script>
import { mapState } from 'vuex';
import QTree from '@/utils/QTree'
export default {
  name: 'TreeviewSelect',

  props: ['props'],

  data: () => ({
    valid: true,
    search: '',
    show_text: '',
    menu: false,
    is_writing: false,
  }),

  computed: {
    /* 
      TODO: make it generic, right now its only for processes
    */
    ...mapState(['allProcesses']),
    processes_tree() {
       return new QTree(this.allProcesses.filter(proc =>  !!Object.fromEntries(this.props.items || [])[proc.id]))
     },

     items_tree() {
      return Object.values(this.processes_tree.get_array_tree()).sort((p1, p2) => p1.name.localeCompare(p2.name));
     },
    /*
      To here must be modified to make it generic
    */

    value() {
      let r = this.props.value || null
      if (
        this.props.value &&
        this.props.multiple &&
        this.props.value.length < 1
      ) {
        r = null
      }
      return r
    },
    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
    },
    item_name() {
      return (this.processes_tree.plain_tree().find(it => it.id == this.props.value) || {}).name;
    },
    selected_item() {
      return this.processes_tree.plain_tree().find(it => it.id == this.props.value);
    },
    text() {
      return this.show_text || this.item_name || '';
    },
    selection() {
      return this.selected_item ? [this.selected_item] : [];
    }
  },


  methods: {
    validate() {
      // TODO: Show error message
      return this.valid
    },
    clear() {
      this.props.value = null;
      this.show_text = null;
      this.update()
    },
    error_state(ok) {
      this.valid = ok
    },
    clear_search() {
      this.search = null;
      if (!this.is_writing) {
        this.show_text = null;
      }
    },
    search_text(text) {
      this.search = text;
      this.show_text = text;
      if (!text || text.length <= 0) {
        this.props.value = null;
      }
      this.menu = true;
    },
    manage_active(item) {
      if (!this.value || this.selection.findIndex(it => it.id == item.id ) < 0) {
        this.props.value = item.id;
        this.show_text = item.name;
        this.search = null;
        this.update(item.id);
      } else {
        this.clear();
      }
      this.menu = false;
    },
    update(value) {
      let res = value;
      this.$emit('update',res);
    },
  },
  watch: {
    menu() {
      if (!this.menu && !this.is_writing) {
        this.clear_search();
      }
    },
    is_writing() {
      if (!this.is_writing && !this.menu) {
        this.clear_search();
      }
    }
  }
}
</script>

